(function () {
  const rates = {
    PH: { currency: 'PHP', rate: 1, locale: 'en-PH' },
    US: { currency: 'USD', rate: 0.0179, locale: 'en-US' },
    SG: { currency: 'SGD', rate: 0.0240, locale: 'en-SG' },
    AU: { currency: 'AUD', rate: 0.0274, locale: 'en-AU' },
    GB: { currency: 'GBP', rate: 0.0141, locale: 'en-GB' },
    JP: { currency: 'JPY', rate: 2.66, locale: 'ja-JP' },
    CA: { currency: 'CAD', rate: 0.0242, locale: 'en-CA' },
    HK: { currency: 'HKD', rate: 0.14, locale: 'en-HK' },
    MY: { currency: 'MYR', rate: 0.084, locale: 'ms-MY' },
    FR: { currency: 'EUR', rate: 0.0165, locale: 'fr-FR' },
    DE: { currency: 'EUR', rate: 0.0165, locale: 'de-DE' },
    IT: { currency: 'EUR', rate: 0.0165, locale: 'it-IT' },
    ES: { currency: 'EUR', rate: 0.0165, locale: 'es-ES' },
    AT: { currency: 'EUR', rate: 0.0165, locale: 'de-AT' },
    BE: { currency: 'EUR', rate: 0.0165, locale: 'nl-BE' },
    BG: { currency: 'EUR', rate: 0.0165, locale: 'bg-BG' },
    BN: { currency: 'BND', rate: 0.0241, locale: 'ms-BN' }
  };

  const PRICE_SELECTORS = [
    '.money',
    '.cart-item__price-wrapper .price',
    '.cart-item__details .price',
    '.cart-item__totals .price',
    '.totals__subtotal-value',
    '.totals .price',
    '.drawer__footer .totals__subtotal-value',
    '.cart-drawer .price',
    '.cart-drawer .totals__subtotal-value',
    '.cart-drawer [class*="price"]'
  ];

  function getCountry() {
    return localStorage.getItem('selected_country') || 'PH';
  }

  function setCountry(code) {
    localStorage.setItem('selected_country', code);
  }

  function getConfig() {
    return rates[getCountry()] || rates.PH;
  }

  function parsePHP(text) {
    if (!text) return NaN;

    return parseFloat(
      text
        .replace(/PHP/gi, '')
        .replace(/[₱,]/g, '')
        .replace(/[^\d.]/g, '')
    );
  }

  function formatPrice(amount, config) {
    return new Intl.NumberFormat(config.locale, {
      style: 'currency',
      currency: config.currency,
      maximumFractionDigits: config.currency === 'JPY' ? 0 : 2
    }).format(amount);
  }

  function getPriceNodes() {
    return document.querySelectorAll(PRICE_SELECTORS.join(','));
  }

  function updateCurrencyLabel(config) {
    document.querySelectorAll('.currency-code').forEach(function (el) {
      el.textContent = config.currency;
    });
  }

  function convertPrices() {
    const config = getConfig();

    updateCurrencyLabel(config);

    getPriceNodes().forEach(function (el) {
      if (!el.dataset.basePhp) {
        const base = parsePHP(el.textContent);
        if (!isNaN(base)) {
          el.dataset.basePhp = base;
        }
      }

      const basePhp = parseFloat(el.dataset.basePhp);
      if (isNaN(basePhp)) return;

      const converted = basePhp * config.rate;
      el.textContent = formatPrice(converted, config) + ' ' + config.currency;
    });
  }

  function bindCountryPicker() {
    document.addEventListener('click', function (e) {
      const item = e.target.closest('[data-value],[data-country-code],a,button');
      if (!item) return;

      const code =
        item.getAttribute('data-value') ||
        item.getAttribute('data-country-code') ||
        item.value;

      if (code && code.length <= 3) {
        setCountry(code.toUpperCase());
        setTimeout(convertPrices, 300);
        setTimeout(convertPrices, 800);
      }
    });

    document.addEventListener('change', function (e) {
      const el = e.target;
      if (
        el.matches('select[name="country_code"]') ||
        el.matches('#CountrySelector') ||
        el.matches('[data-country-selector]')
      ) {
        setCountry(el.value.toUpperCase());
        convertPrices();
        setTimeout(convertPrices, 500);
      }
    });
  }

  function observeChanges() {
    const observer = new MutationObserver(function () {
      setTimeout(convertPrices, 100);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindCountryPicker();
    convertPrices();
    setTimeout(convertPrices, 500);
    setTimeout(convertPrices, 1200);
    observeChanges();
  });
})();